import React from 'react';
import { Container, Col, Row, Table } from 'react-bootstrap';
import { Header, Footer } from '../../Container';

const members = [
	{
		name: 'A',
		tags: '',
		date: '',
	},
	{
		name: 'Alda Mayhall',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'Alex Havlik',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'B',
		tags: '',
		date: '',
	},
	{
		name: 'C',
		tags: '',
		date: '',
	},
	{
		name: 'Cammy Goldsborough',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'Carmelita Guerin',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'Cindi Turbeville',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'D',
		tags: '',
		date: '',
	},
	{
		name: 'Debbi Penfield',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'Delfina Samms',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'Dante Follmer',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'Dixie Henningsen',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'E',
		tags: '',
		date: '',
	},
	{
		name: 'Edwin Macaraeg',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'Elvina Kesselman',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
	{
		name: 'Emelia Candanoza',
		tags: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
		date: '06/15-25/2022',
	},
];

function Members() {
	return (
		<Container fluid='true'>
			<Header type='recruiter' />
			<Container className='mt-3' fluid='md'>
				<Row>
					<Col md={9} xs className='mt-3 mb-3'>
						<input type='text' placeholder='Filter' />
					</Col>
					<Col md={3} xs className='mt-3 mb-3 p-2'>
						<input type='text' placeholder='Search' />
					</Col>
				</Row>
				<Row>
					<Col>
						<Table>
							<thead>
								<tr>
									<th className='col-md-3'>Name</th>
									<th className='col-md-7'>Tags</th>
									<th className='col-md-1'> Date range availability</th>
								</tr>
							</thead>
							<tbody>
								{members.map((m, index) => (
									<tr
										key={index}
										className={
											m.tags === '' && m.date === '' ? 'table-secondary' : ''
										}
									>
										<td
											className={
												m.tags === '' && m.date === '' ? 'letter-key' : ''
											}
										>
											{m.name}
										</td>
										<td>{m.tags}</td>
										<td>{m.date}</td>
									</tr>
								))}
							</tbody>
						</Table>
					</Col>
				</Row>
				<Footer />
			</Container>
		</Container>
	);
}

export default Members;
